<template>
  <div>
    <RegisterSection />
    <section1 />
    <section2 />
    <!-- <LpFooter /> -->
  </div>
</template>
<script>
import RegisterSection from './pageSections/register.vue'
import section1 from './pageSections/section-1.vue'
import section2 from './pageSections/section-2.vue'
// import LpFooter from './pageSections/lp-footer.vue'
export default {
  components: { 
    RegisterSection, 
    section1, 
    section2, 
    // LpFooter, 
  },
}
</script>
<style >
  @import '../../../../static/fxView/css/lp-style.css'
</style>



// WEBPACK FOOTER //
// src/components/fxView/lp/demo-account.vue